module.exports = __webpack_public_path__ + "static/media/application-crop-mobile.28a3fad3.jpg";